goog.provide("shadow.js.shim.module$$mui$material$IconButton$default");
shadow.js.shim.module$$mui$material$IconButton$default = shadow.js.shim.module$$mui$material$IconButton.default;
